<ul style="display: flex;list-style: none;justify-content: flex-end;">
    <li style="padding: 0 1em"
        *ngFor="let lang of translate.getLangs()">
        <a style="text-transform: uppercase"
           href="#"
           (click)="translate.use(lang); store.state.common.lang = lang; false;">{{ lang }}</a>
    </li>
</ul>
<app-wrapper [wrapperCssClass]="'body-special'"
             [isLoginPage]="true">
    <div class="page-signin col"
         style="margin-top: 10vh">
        <div class="signin-body">
            <div class="container">
                <div class="form-container">
                    <h3 style="text-align: center;text-transform: uppercase;font-weight: 300">{{ 'login.title' | translate }}</h3>
                    <div class="form-group">
                        <!-- KEYCLOAK -->
                        <button *ngIf="keycloakActive" (click)="login()" class="btn btn-primary btn-lg btn-block text-light">
                            {{ 'login.title' | translate }}
                        </button>
                        <!-- CAS -->
                        <a *ngIf="!keycloakActive" href="{{ loginLink }}"
                           type="submit"
                           class="btn btn-primary btn-lg btn-block text-light">{{ 'Authenticate via CAS' | translate }}
                        </a>
                    </div>
                    <h3 *ngIf="error" style="font-weight: 400" class="text-danger text-center">
                        {{error | translate}}
                    </h3>
                </div>
            </div>
        </div>
    </div>
</app-wrapper>
